import script from "./AccountRegister.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountRegister.vue?vue&type=script&setup=true&lang=js"

import "./AccountRegister.vue?vue&type=style&index=0&id=5d7cb6ef&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d7cb6ef"]])

export default __exports__